import { render } from "./Character.vue?vue&type=template&id=3de2209a"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"

import "./Character.vue?vue&type=style&index=0&id=3de2209a&lang=scss"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__